/* Gerekseal teması – etkileşimler (bağımlılık yok) */
(function () {
  'use strict';

  const T = window.theme || { routes: {}, strings: {} };
  const R = T.routes || {};
  const S = T.strings || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const isDesktop = () => window.matchMedia('(min-width: 990px)').matches;
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- Para biçimi ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || T.moneyFormat || '{{amount}}';
    const fmt = (n, dec, thou, decSep) => {
      const fixed = (n / 100).toFixed(dec);
      const [i, d] = fixed.split('.');
      const int = i.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return d ? int + decSep + d : int;
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Bildirim ---------- */
  let toastTimer;
  function toast(html, ms = 2600) {
    const el = $('#Toast');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-show'), ms);
  }

  /* ---------- Kaydırma kilidi ---------- */
  let lockCount = 0;
  const lock = () => { lockCount++; document.body.classList.add('is-locked'); };
  const unlock = () => { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); };

  /* ==========================================================================
     Çekmeceler
     ========================================================================== */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d || d.classList.contains('is-open')) return;
    if (d.classList.contains('drawer--desktop-static') && isDesktop()) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    lock();
    const panel = $('.drawer__panel', d);
    setTimeout(() => panel && panel.focus({ preventScroll: true }), 50);
  }
  function closeDrawer(d) {
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    unlock();
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); closeSearch(); openDrawer(opener.dataset.drawerOpen); return; }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }
    const cartLink = e.target.closest('[data-cart-open]');
    if (cartLink && T.cartType === 'drawer' && $('#CartDrawer') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      closeDrawer($('#MenuDrawer'));
      openDrawer('CartDrawer');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('[data-drawer].is-open').forEach(closeDrawer);
    closeSearch();
  });

  /* ==========================================================================
     Arama penceresi + anlık arama
     ========================================================================== */
  function openSearch() {
    const m = $('[data-search-modal]');
    if (!m) { window.location.href = R.search; return; }
    $$('[data-drawer].is-open').forEach(closeDrawer);
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    lock();
    setTimeout(() => { const i = $('[data-predictive-input]', m); i && i.focus(); }, 60);
  }
  function closeSearch() {
    const m = $('[data-search-modal]');
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    m.setAttribute('aria-hidden', 'true');
    unlock();
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { closeSearch(); }
  });

  const escapeHtml = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const runPredictive = debounce(async (input) => {
    const box = $('[data-predictive-results]');
    const popular = $('[data-predictive-popular]');
    const q = input.value.trim();
    if (!box) return;
    if (q.length < 2) { box.innerHTML = ''; if (popular) popular.hidden = false; return; }
    try {
      const url = `${R.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
      const res = await fetch(url);
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (popular) popular.hidden = products.length > 0;
      if (!products.length) { box.innerHTML = `<p class="predictive__empty">${escapeHtml(S.noResults)}</p>`; return; }
      box.innerHTML = '<ul class="predictive__list">' + products.map((p) => {
        const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}&width=120" alt="" loading="lazy" width="56" height="56">` : '<img alt="">';
        const price = p.price ? formatMoney(Math.round(parseFloat(p.price) * 100)) : '';
        return `<li><a class="predictive__item" href="${p.url}">${img}<div><strong>${escapeHtml(p.title)}</strong><span>${price}</span></div></a></li>`;
      }).join('') + `</ul><a class="predictive__all" href="${R.search}?q=${encodeURIComponent(q)}&options[prefix]=last">${escapeHtml(S.viewAll)} →</a>`;
    } catch (err) { box.innerHTML = ''; }
  }, 250);
  document.addEventListener('input', (e) => {
    if (e.target.matches('[data-predictive-input]')) runPredictive(e.target);
  });

  /* ==========================================================================
     Slider (kaydırmalı: hero, ürün rafları, galeri, yorumlar)
     ========================================================================== */
  function initSlider(root) {
    if (root.dataset.sliderReady) return;
    const track = $('[data-slider-track]', root);
    if (!track) return;
    root.dataset.sliderReady = '1';
    const slides = () => $$(':scope > [data-slide]', track);
    const prev = $(':scope > [data-slider-prev], :scope [data-slider-prev]', root);
    const next = $(':scope > [data-slider-next], :scope [data-slider-next]', root);
    const dots = $$('[data-slider-dot]', root);
    const loop = root.classList.contains('hero');
    const step = () => { const s = slides()[0]; return s ? s.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0) : track.clientWidth; };
    const index = () => Math.round(track.scrollLeft / Math.max(1, step()));
    const maxScroll = () => track.scrollWidth - track.clientWidth - 2;

    function goTo(i, smooth = true) {
      const n = slides().length;
      if (!n) return;
      if (loop) i = (i + n) % n; else i = Math.max(0, Math.min(i, n - 1));
      track.scrollTo({ left: i * step(), behavior: smooth ? 'smooth' : 'auto' });
    }
    root.sliderGoTo = goTo;

    function update() {
      const i = index();
      dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
      if (!loop) {
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= maxScroll();
      }
      root.dispatchEvent(new CustomEvent('slider:change', { detail: { index: i } }));
    }
    track.addEventListener('scroll', debounce(update, 60), { passive: true });
    if (prev) prev.addEventListener('click', () => {
      if (track.classList.contains('products')) track.scrollBy({ left: -track.clientWidth * 0.9, behavior: 'smooth' });
      else goTo(index() - 1);
    });
    if (next) next.addEventListener('click', () => {
      if (track.classList.contains('products')) track.scrollBy({ left: track.clientWidth * 0.9, behavior: 'smooth' });
      else goTo(index() + 1);
    });
    dots.forEach((d) => d.addEventListener('click', () => goTo(parseInt(d.dataset.sliderDot, 10))));

    const start = parseInt(root.dataset.start || '0', 10);
    if (start) requestAnimationFrame(() => goTo(start, false));
    update();

    const delay = parseInt(root.dataset.autoplay || '0', 10);
    if (delay > 0 && slides().length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      let timer;
      const play = () => { stop(); timer = setInterval(() => goTo(index() + 1), delay); };
      const stop = () => clearInterval(timer);
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      root.addEventListener('touchstart', stop, { passive: true });
      root.addEventListener('focusin', stop);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : play()));
      root.sliderStop = stop;
      play();
    }
  }

  /* ==========================================================================
     Duyuru bandı (sırayla değişen mod)
     ========================================================================== */
  function initAnnouncement(root) {
    if (root.dataset.ready || root.dataset.announce !== 'rotate') return;
    root.dataset.ready = '1';
    const items = $$('.announce__item', root);
    if (items.length < 2) return;
    let i = 0;
    const speed = parseFloat(getComputedStyle(root).getPropertyValue('--ann-speed')) || 32;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, Math.max(3000, speed * 150));
  }

  /* ==========================================================================
     Geri sayım
     ========================================================================== */
  function initCountdown(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const end = new Date(root.dataset.countdown).getTime();
    const timer = $('[data-countdown-timer]', root);
    const expired = $('[data-countdown-expired]', root);
    if (isNaN(end)) { if (timer) timer.hidden = true; return; }
    const pad = (n) => String(Math.floor(n)).padStart(2, '0');
    const els = { d: $('[data-cd="d"]', root), h: $('[data-cd="h"]', root), m: $('[data-cd="m"]', root), s: $('[data-cd="s"]', root) };
    function tick() {
      let diff = (end - Date.now()) / 1000;
      if (diff <= 0) {
        clearInterval(iv);
        if (root.dataset.hideExpired === 'true' && !window.Shopify?.designMode) { root.closest('.shopify-section').hidden = true; return; }
        if (timer) timer.hidden = true;
        if (expired) expired.hidden = false;
        return;
      }
      els.d.textContent = pad(diff / 86400);
      els.h.textContent = pad((diff % 86400) / 3600);
      els.m.textContent = pad((diff % 3600) / 60);
      els.s.textContent = pad(diff % 60);
    }
    const iv = setInterval(tick, 1000);
    tick();
  }

  /* ==========================================================================
     Sepet
     ========================================================================== */
  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || S.error);
    return data;
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
      el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
    });
  }

  async function refreshCart() {
    const [cart, html] = await Promise.all([
      fetch(`${R.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()),
      $('#CartDrawer') ? fetch(`${R.root}?section_id=cart-drawer`).then((r) => r.text()) : Promise.resolve(null)
    ]);
    setCount(cart.item_count);
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-cart-drawer-panel]', doc);
      const panel = $('#CartDrawer [data-cart-drawer-panel]');
      if (fresh && panel) panel.innerHTML = fresh.innerHTML;
    }
    return cart;
  }

  async function addToCart(items, button) {
    const label = button ? $('[data-add-label], [data-quick-add-label]', button) : null;
    const original = label ? label.textContent : '';
    if (button) button.classList.add('is-loading');
    try {
      const added = await cartRequest(`${R.cartAdd}.js`, { items });
      if (T.cartType === 'page') { window.location.href = R.cart; return; }
      await refreshCart();
      if (button && label) {
        button.classList.add('is-done');
        label.textContent = S.added + ' ✓';
        setTimeout(() => { button.classList.remove('is-done'); label.textContent = original; }, 1600);
      }
      if (T.cartType === 'drawer' && $('#CartDrawer')) {
        openDrawer('CartDrawer');
      } else {
        const title = added.items && added.items[0] ? added.items[0].product_title : '';
        toast(`<span>${escapeHtml(title)} ${escapeHtml(S.addedToast)}</span><a href="${R.cart}">${escapeHtml(S.viewCart)}</a>`);
      }
    } catch (err) {
      toast(escapeHtml(err.message || S.error), 3500);
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  async function changeLine(line, quantity) {
    const drawer = $('#CartDrawer');
    const row = $$(`[data-cart-line="${line}"]`);
    row.forEach((r) => r.classList.add('is-updating'));
    try {
      await cartRequest(`${R.cartChange}.js`, { line: parseInt(line, 10), quantity: Math.max(0, parseInt(quantity, 10) || 0) });
      if (document.body.classList.contains('template-cart') && !(drawer && drawer.classList.contains('is-open'))) {
        window.location.reload();
        return;
      }
      await refreshCart();
    } catch (err) {
      toast(escapeHtml(err.message || S.error), 3500);
      row.forEach((r) => r.classList.remove('is-updating'));
    }
  }

  document.addEventListener('click', (e) => {
    const lc = e.target.closest('[data-line-change]');
    if (lc) { e.preventDefault(); changeLine(lc.dataset.lineChange, lc.dataset.qty); return; }

    const quick = e.target.closest('[data-quick-add]');
    if (quick && !quick.disabled) {
      e.preventDefault();
      addToCart([{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }], quick);
      return;
    }

    const pill = e.target.closest('[data-card-variant]');
    if (pill) {
      const card = pill.closest('[data-product-card]');
      $$('[data-card-variant]', card).forEach((p) => p.classList.toggle('is-active', p === pill));
      const priceWrap = $('.card__price', card);
      if (priceWrap) {
        const compare = pill.dataset.compare;
        priceWrap.innerHTML = `<span class="price${compare ? ' price--sale' : ''}"><span class="price__current">${pill.dataset.price}</span>${compare ? `<s class="price__compare">${compare}</s>` : ''}</span>`;
      }
      const btn = $('[data-quick-add]', card);
      if (btn) {
        const available = pill.dataset.available === 'true';
        btn.dataset.quickAdd = pill.dataset.cardVariant;
        btn.disabled = !available;
        const l = $('[data-quick-add-label]', btn);
        if (l) l.textContent = available ? S.addToCart : S.soldOut;
      }
    }
  });
  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-line-input]')) changeLine(e.target.dataset.lineInput, e.target.value);
    if (e.target.matches('[data-cart-note]')) {
      cartRequest(`${R.cart}/update.js`, { note: e.target.value }).catch(() => {});
    }
  });

  /* ==========================================================================
     Ürün sayfası
     ========================================================================== */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const jsonEl = $('[data-product-json]', root);
    const data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
    const formId = root.dataset.formId;
    const form = document.getElementById(formId);
    const picker = $('[data-variant-picker]', root);
    const gallery = $('[data-gallery]', root);
    const slider = gallery ? $('[data-slider]', gallery) : null;
    const sticky = $('[data-sticky-atc]');

    // Galeri küçük resimleri
    if (gallery && slider) {
      const thumbs = $$('[data-thumb]', gallery);
      thumbs.forEach((t) => t.addEventListener('click', () => slider.sliderGoTo && slider.sliderGoTo(parseInt(t.dataset.thumb, 10))));
      slider.addEventListener('slider:change', (e) => thumbs.forEach((t, i) => t.classList.toggle('is-active', i === e.detail.index)));
    }

    // Adet
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-qty-step]');
      if (!b) return;
      const input = $('.qty__input', b.parentElement);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    });

    // Sepete ekle
    if (form) {
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const fd = new FormData(form);
        const id = parseInt(fd.get('id'), 10);
        const quantity = parseInt(fd.get('quantity') || '1', 10);
        const properties = {};
        for (const [k, v] of fd.entries()) {
          const m = k.match(/^properties\[(.+)\]$/);
          if (m && v) properties[m[1]] = v;
        }
        const item = { id, quantity };
        if (Object.keys(properties).length) item.properties = properties;
        const submitter = e.submitter && e.submitter.matches('[data-sticky-add]') ? e.submitter : $('[data-add-button]', form);
        addToCart([item], submitter);
      });
    }

    // Varyant seçimi
    function currentOptions() {
      const values = [];
      $$('[data-option-index]', picker).forEach((el) => {
        const i = parseInt(el.dataset.optionIndex, 10);
        if (el.tagName === 'SELECT') values[i] = el.value;
        else if (el.checked) values[i] = el.value;
      });
      return values;
    }
    function updateVariant() {
      const opts = currentOptions();
      const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      // Etiketler ve aktif butonlar
      opts.forEach((val, i) => { const l = $(`[data-option-label="${i}"]`, root); if (l) l.textContent = val; });
      $$('.variants__pills .pill', picker).forEach((p) => { const inp = $('input', p); p.classList.toggle('is-active', inp.checked); });
      // Stokta olmayan seçenekleri işaretle
      $$('.variants__pills input', picker).forEach((inp) => {
        const i = parseInt(inp.dataset.optionIndex, 10);
        const test = opts.slice(); test[i] = inp.value;
        const match = data.variants.find((v) => v.options.every((o, k) => o === test[k]));
        inp.parentElement.classList.toggle('is-unavailable', !match || !match.available);
      });

      const addBtns = $$('[data-add-button], [data-sticky-add]');
      if (!variant) {
        addBtns.forEach((b) => { b.disabled = true; const l = $('[data-add-label]', b); if (l) l.textContent = S.unavailable; });
        return;
      }
      const input = form && $('[data-variant-input]', form);
      if (input) input.value = variant.id;
      addBtns.forEach((b) => { b.disabled = !variant.available; const l = $('[data-add-label]', b); if (l) l.textContent = variant.available ? S.addToCart : S.soldOut; });

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      const priceEl = $('[data-product-price]', root);
      if (priceEl) priceEl.innerHTML = `<span class="price${onSale ? ' price--sale' : ''}"><span class="price__current">${formatMoney(variant.price)}</span>${onSale ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : ''}</span>`;
      const badge = $('[data-sale-badge]', root);
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) badge.textContent = `%${Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)} ${badge.dataset.suffix || ''}`;
      }
      const sp = $('[data-sticky-price]');
      if (sp) sp.textContent = formatMoney(variant.price);

      if (variant.featured_media && slider && slider.sliderGoTo) {
        const idx = $$('[data-slide]', slider).findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (idx >= 0) slider.sliderGoTo(idx);
      }
      if (!window.Shopify || !window.Shopify.designMode) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    if (picker) {
      picker.addEventListener('change', updateVariant);
      updateVariant();
    }

    // Mobil yapışkan sepete ekle
    const buy = $('[data-buy-buttons]', root);
    if (sticky && buy) {
      let ticking = false;
      const check = () => {
        ticking = false;
        const show = buy.getBoundingClientRect().bottom < 0;
        if (show !== sticky.classList.contains('is-visible')) {
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        }
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      check();
    }
  }

  /* ==========================================================================
     Koleksiyon filtreleri ve sıralama
     ========================================================================== */
  function facetUrl(form) {
    const params = new URLSearchParams();
    for (const [k, v] of new FormData(form).entries()) if (v !== '') params.append(k, v);
    const sort = $('[data-facet-sort]');
    if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    return `${form.getAttribute('action') || window.location.pathname}?${params.toString()}`;
  }
  function initFacets(root) {
    const form = $('[data-facet-form]', root);
    const sort = $('[data-facet-sort]', root);
    if (form && !form.dataset.ready) {
      form.dataset.ready = '1';
      const go = debounce(() => { window.location.href = facetUrl(form); }, 500);
      form.addEventListener('change', () => { if (isDesktop()) go(); });
      form.addEventListener('submit', (e) => { e.preventDefault(); window.location.href = facetUrl(form); });
    }
    if (sort && !sort.dataset.ready) {
      sort.dataset.ready = '1';
      sort.addEventListener('change', () => {
        if (form) { window.location.href = facetUrl(form); return; }
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* ==========================================================================
     Footer akordeonları: masaüstünde hep açık
     ========================================================================== */
  function syncFooter() {
    const desktop = window.matchMedia('(min-width: 750px)').matches;
    $$('[data-footer-acc]').forEach((d) => {
      if (desktop) d.setAttribute('open', '');
      else if (!d.dataset.touched) d.removeAttribute('open');
    });
  }
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-footer-acc] > summary');
    if (s) {
      if (window.matchMedia('(min-width: 750px)').matches) e.preventDefault();
      else s.parentElement.dataset.touched = '1';
    }
  });

  /* ==========================================================================
     Benzer ürünler
     ========================================================================== */
  async function initRecommendations(root) {
    if (root.dataset.ready || root.children.length) return;
    root.dataset.ready = '1';
    try {
      const html = await fetch(root.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = $('[data-recommendations]', doc);
      if (fresh && fresh.innerHTML.trim()) { root.innerHTML = fresh.innerHTML; init(root); }
    } catch (err) { /* sessiz geç */ }
  }

  /* ==========================================================================
     Yapışkan header yüksekliği
     ========================================================================== */
  function trackHeader() {
    const sec = $('.section-header');
    if (!sec) return;
    const set = () => {
      const sticky = getComputedStyle(sec).position === 'sticky';
      document.documentElement.style.setProperty('--header-h', sticky ? sec.offsetHeight + 'px' : '0px');
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(sec);
  }

  /* ==========================================================================
     Başlat
     ========================================================================== */
  function init(root = document) {
    $$('[data-slider]', root).forEach(initSlider);
    $$('[data-announce]', root).forEach(initAnnouncement);
    $$('[data-countdown]', root).forEach(initCountdown);
    $$('[data-product]', root).forEach(initProduct);
    $$('[data-recommendations]', root).forEach(initRecommendations);
    initFacets(root);
    syncFooter();
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
    trackHeader();
    window.addEventListener('resize', debounce(syncFooter, 150));
  });

  // Tema editörü desteği
  document.addEventListener('shopify:section:load', (e) => { init(e.target); trackHeader(); });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('[data-slide]');
    const slider = slide && slide.closest('[data-slider]');
    if (slider && slider.sliderGoTo) {
      if (slider.sliderStop) slider.sliderStop();
      slider.sliderGoTo($$('[data-slide]', slider).indexOf(slide));
    }
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('#CartDrawer')) openDrawer('CartDrawer');
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('#CartDrawer')) closeDrawer($('#CartDrawer'));
  });

  window.GerekTheme = { formatMoney, toast, addToCart, refreshCart, openDrawer, init };
})();
